import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class InventoryService {
  private apiUrl = '/spring/inventories';
  private apiStocksUrl = '/spring/inventories/stocks';

  constructor(private http: HttpService) { }

  start(
    ownerId: number,
    inventoryDt: Date,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl;
    const date = new Date(inventoryDt);
    const jsonInput = {
      ownerId: ownerId,
      inventoryDt: `${date.getFullYear()}'/'${('0' + (date.getMonth() + 1)).slice(-2)}'/'${('0' + date.getDate()).slice(-2)}`,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }

  end(
    ownerId: number,
    inventoryId: number,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl + "/end"}/${inventoryId}`;
    const jsonInput = {
      ownerId: ownerId,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }

  cancel(
    ownerId: number,
    inventoryId: number,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl + "/cancel"}/${inventoryId}`;
    const jsonInput = {
      ownerId: ownerId,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }
    
  getStock(ownerId: number, event?: number): Promise<any> {
    let url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiStocksUrl}/${ownerId}`;
    if(event)url = url+"?typeDiffFl=1";
    return this.http.get(url);
  }

  updateStock(
    inventoryId: number,
    inventorystockList: any
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiStocksUrl}/${inventoryId}`;
    const jsonInput = inventorystockList;
    return this.http.put(url, jsonInput);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/inventory/inventory.service.ts